import smartImg from '../../media/smart.svg';
import expertImg from '../../media/expert.svg';

export const ACCOUNT_MODE = {
  EXPERT: 0,
  UNIFIED_SMART: 2,
};

export const ACCOUNT_MODE_NAME = {
  EXPERT: 'expert',
  UNIFIED_SMART: 'unifiedsmart',
};

export const ACCOUNT_MODE_INFO = {
  [ACCOUNT_MODE.EXPERT]: {
    name: ACCOUNT_MODE_NAME.EXPERT,
    title: _TL_('Take full control'),
    description: _TL_('Best for experienced advertisers and marketing professionals.'),
    imgSrc: expertImg,
    imgAlt: _TL_('Expert mode'),
    introTitle: _TL_('With Expert mode, you can:'),
    introTexts: [
      _TL_('Fine-tune every aspect of your ad campaigns.'),
      _TL_('Access advanced, detailed performance reporting and tracking.'),
      _TL_('Choose from multiple campaign types (shopping, video, and more).'),
      _TL_('Run standalone audience campaigns across Bing, MSN, Outlook, and Microsoft Edge.')],
  },
  [ACCOUNT_MODE.UNIFIED_SMART]: {
    name: ACCOUNT_MODE_NAME.UNIFIED_SMART,
    title: _TL_('Streamlined, simple experience'),
    description: _TL_('Best for novice advertisers and those who want to save time and effort.'),
    imgSrc: smartImg,
    imgAlt: _TL_('Smart mode'),
    introTitle: _TL_('With Smart mode, you can:'),
    introTexts: [
      _TL_('Get started quickly with a streamlined campaign setup experience.'),
      _TL_('Benefit from automated optimizations and a time-saving approach.'),
      _TL_('Expand your customer reach easily by running your ads on Facebook, Google, and Instagram.'),
      _TL_('Track performance with key metrics, including conversion tracking.')],
  },
};
